import ManageCampaignTable from './ManageCampaignTable'

export default ManageCampaignTable
